<template>
  <section class="scrollable-table">
    <nav v-if="overflow" class="table-scroll-actions" aria-label="股票列表横向滚动">
      <span>更多指标</span>
      <button type="button" aria-label="向左滚动股票列表" :disabled="!canLeft" @click="move(-1)">‹</button>
      <button type="button" aria-label="向右滚动股票列表" :disabled="!canRight" @click="move(1)">›</button>
    </nav>
    <div ref="viewport" class="table-scroll-viewport" @scroll="scrolled"><div ref="content" class="table-scroll-content"><slot /></div></div>
  </section>
</template>
<script>
export default {
  data: () => ({ overflow: false, canLeft: false, canRight: false }),
  mounted() {
    this.observer = new ResizeObserver(this.measure)
    this.observer.observe(this.$refs.viewport); this.observer.observe(this.$refs.content)
    this.measure()
  },
  updated() { this.measure() },
  beforeDestroy() { if (this.observer) this.observer.disconnect() },
  methods: {
    measure() {
      const el = this.$refs.viewport
      if (!el) return
      this.overflow = el.scrollWidth > el.clientWidth + 1
      this.canLeft = el.scrollLeft > 1
      this.canRight = el.scrollLeft + el.clientWidth < el.scrollWidth - 1
    },
    move(direction) { const el = this.$refs.viewport; el.scrollBy({ left: direction * Math.max(240, el.clientWidth * 0.75), behavior: 'auto' }) },
    reset() { this.$refs.viewport.scrollTop = 0; this.$refs.viewport.scrollLeft = 0; this.measure() },
    scrolled(event) { this.measure(); this.$emit('scroll', event) }
  }
}
</script>
<style scoped>
.scrollable-table { display: flex; flex-direction: column; flex: 1; min-height: 0; min-width: 0; width: 100%; overflow: hidden; }
.table-scroll-viewport { flex: 1; min-height: 0; min-width: 0; overflow: auto; overscroll-behavior: contain; scrollbar-width: thin; scrollbar-color: var(--theme-muted) var(--theme-panel); }
.table-scroll-content { min-width: 100%; width: 100%; }
.table-scroll-actions { display: flex; flex: none; justify-content: flex-end; align-items: center; gap: 8px; padding: 3px 10px; background: var(--theme-header); color: var(--theme-muted); font-size: 12px; border-bottom: 1px solid var(--theme-border); }
.table-scroll-actions button { width: 30px; height: 24px; padding: 0; line-height: 20px; font-size: 22px; border: 1px solid var(--theme-border); border-radius: 4px; background: var(--theme-input); color: var(--theme-label); cursor: pointer; }
.table-scroll-actions button:disabled { opacity: .35; cursor: default; }
</style>
